import React from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { BLOG_ARTICLES } from "../blog/articles";
import "../style/Blog.css";

const formatDate = (rawDate) =>
  new Date(rawDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

const getCreatedDate = (article) => article.createdDate || article.date;
const getAuthor = (article) => article.author || "The Picky Kitty";
const getLegacyImageSrc = (coverImage) => {
  if (!coverImage) return null;
  if (coverImage.startsWith("http") || coverImage.startsWith("/")) return coverImage;
  return `/blog/${coverImage}`;
};

const getPreviewImageSrc = (article) => {
  if (article?.imageKey) return `/blog/preview/${article.imageKey}`;
  return getLegacyImageSrc(article?.coverImage);
};

const Blog = () => {
  return (
    <div className="blog-container">
      <div className="page-header">
        <h1 className="page-title">Blog</h1>
        <img
          src="/picky-kitty/blog.png"
          alt="The Picky Kitty Blog"
          className="header-image"
        />
      </div>

      <div className="blog-list">
        {BLOG_ARTICLES.map((article) => (
          <article key={article.slug} className="blog-list-item">
            <Link to={`/Blog/${article.slug}`} className="blog-list-link">
              {getPreviewImageSrc(article) ? (
                <img
                  src={getPreviewImageSrc(article)}
                  alt={article.coverImageAlt || article.title}
                  className="blog-list-image"
                  loading="lazy"
                />
              ) : (
                <div className="blog-list-image blog-list-image-placeholder" />
              )}

              <div className="blog-list-content">
                <Typography variant="h4" component="h2" className="blog-list-title">
                  {article.title}
                </Typography>
                <div className="blog-list-meta">
                  <span className="blog-list-meta-item">{formatDate(getCreatedDate(article))}</span>
                  <span className="blog-list-meta-separator">|</span>
                  <span className="blog-list-meta-item">{getAuthor(article)}</span>
                </div>
                <Typography variant="body1" className="blog-list-preview">
                  {article.summary}
                </Typography>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Blog;
